module.exports = __webpack_public_path__ + "img/egg.23abfb14.svg";